import TableCellRenderer from '../../../../table/TableCellRenderer'
import $ from 'jquery'


class BalanceRulesRenderer extends TableCellRenderer {

    init(formatter, {
        onClickHandler = () => {},
        onMouseOverHandler = () => {},
        onMouseOutHandler = () => {},
        onMouseMoveHandler = () => {}
    }) {
        this.formatter = formatter
        this.onClickHandler = onClickHandler
        this.onMouseOverHandler = onMouseOverHandler
        this.onMouseOutHandler = onMouseOutHandler
        this.onMouseMoveHandler = onMouseMoveHandler

        return this
    }

    getCellClassName(cell) {
        var data = this.getBalanceFromCellValue(cell.getValue());
        var result = [this.getCellGeneralClassName()];

        if (!data)
            result.push("noBalance");
        else if (data.defaultRules)
            result.push("defaultRules");

        result.push(this._customClassName());

        return result;
    }


    getCellGeneralClassName() {
        return this.mixin.cellGeneralClassName;
    }

    getBalanceFromCellValue(value) {
        var balanceData = this.mixin.getBalanceFromCellValue(value);
        if (balanceData) {
            balanceData.hireDate = value.hireDate;
        }
        return balanceData;
    }

    generateContent(cell) {
        var data = this.getBalanceFromCellValue(cell.getValue());

        if (!data)
            return;

        var cellEl = cell.getCellEl();

        if (!data.defaultRules || this._handleDefaultPTORules())
            cellEl.innerHTML = !data ? "" : this._getRuleValue(data);

        if (this.onClickHandler)
            cellEl.onclick = e => this.onClickHandler(e, data, cell)

        if (this.onMouseOverHandler)
            $(cellEl).hover(e => this.onMouseOverHandler(e, data), this.onMouseOutHandler)

        if (this.onMouseMoveHandler)
            $(cellEl).mousemove(this.onMouseMoveHandler)

    }

    _getRuleValue(ptoData) {
        // abstract
    }

    _customClassName(ptoData) {
        // abstract
    }

    _handleDefaultPTORules(ptoData) {
        return false;
    }
}

export default BalanceRulesRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/BalanceRulesRenderer.js